import {
	FieldType,
	IFormTableSchema,
	ColumnMetadata,
	TableMetadata
} from "./types";
import { Property } from "@ploy-lib/types";

export class PropertiesSchema implements IFormTableSchema<Property> {
	tableMetadata: TableMetadata<Partial<Property>> = {};

	columnMetadata: Partial<Record<keyof Property, ColumnMetadata<Property>>> = {
		refinance: {
			fieldType: FieldType.Checkbox,
			alwaysEditable: true
		},
		propertyInformation: {
			fieldType: FieldType.Text
		},
		streetName: {
			fieldType: FieldType.Text,
			displayValue: (value: any, rowData: Property) => {
				return `${rowData.streetName} ${rowData.addressNumber || ""}${
					rowData.addressLetter || ""
				}, ${padPostalCode(rowData.postalCode) || ""}, ${
					rowData.postalPlace || ""
				}`;
			}
		},
		cadastralNumber: {
			fieldType: FieldType.Text
		},
		municipalityNumber: {
			fieldType: FieldType.Text
		},
		cadastralUnitNumber: {
			fieldType: FieldType.Text
		},
		unitNumber: {
			fieldType: FieldType.Text
		},
		leaseholdUnitNumber: {
			fieldType: FieldType.Text
		},
		valueEnteredByCustomer: {
			fieldType: FieldType.Currency
		},
		estimatedValue: {
			fieldType: FieldType.Currency
		},
		utilizedValue: {
			fieldType: FieldType.Currency
		},
		utilizedSecurityValue: {
			fieldType: FieldType.Currency
		},
		owners: {
			fieldType: FieldType.Multiselect
		},
		eAppraisalReference: {
			fieldType: FieldType.Text
		}
	};
}

const padPostalCode = (postalCode: string | undefined) =>
	postalCode?.padStart(4, "0");
